<template>
  <calc-form-item :title="title">
    <div class="fields_grid">
      <calc-number-input
        v-for="i in 3"
        :key="i"
        v-model="loadValue[i - 1][0]"
        :min="0"
        :max="100"
        :label="`S${i}`"
        addon="kN/m2"
      />
    </div>

    <div>
      <div class="fields_grid">
        <calc-number-input
          v-for="i in 3"
          :key="i"
          v-model="loadValue[i - 1][1]"
          :min="0"
          :max="999"
          :label="`L${i}`"
          addon="m"
        />
      </div>

      <transition name="anim-slideX">
        <div v-if="isLoadUsed">
          <calc-length-match-indicator
            :l-units-length="lUnitsLength"
            :model-spans-length="modelSpansLength"
          />
        </div>
      </transition>
    </div>
  </calc-form-item>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import CalcLengthMatchIndicator from "./CalcLengthMatchIndicator";
import CalcIllustration from "./CalcIllustration";

export default {
  components: {
    CalcLengthMatchIndicator,
    CalcIllustration,
  },

  props: {
    title: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    ...mapState("calculator", ["calculation"]),

    ...mapGetters("calculator", ["load", "modelSpansLength"]),

    loadValue() {
      return this.load("snow", "accumulation").value;
    },

    isLoadUsed() {
      return this.loadValue[0][0] + this.loadValue[1][0] + this.loadValue[2][0];
    },

    lUnitsLength() {
      return +(
        this.loadValue[0][1] +
        this.loadValue[1][1] +
        this.loadValue[2][1]
      ).toFixed(2);
    },

    lengthsMatch() {
      return this.lUnitsLength == this.modelSpansLength;
    },
  },
};
</script>
